import { render, staticRenderFns } from "./kw_list_table_block.vue?vue&type=template&id=361cbd16&scoped=true&"
import script from "./kw_list_table_block.vue?vue&type=script&lang=js&"
export * from "./kw_list_table_block.vue?vue&type=script&lang=js&"
import style0 from "./kw_list_table_block.vue?vue&type=style&index=0&id=361cbd16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361cbd16",
  null
  
)

component.options.__file = "kw_list_table_block.vue"
export default component.exports